module.exports = "<button mat-button routerLink=\"/login\" routerLinkActive=\"active\">Inloggen</button>\n"